import React from "react";
import styled from 'styled-components';
import { HorizontalStack, SmartContainer } from "../../../styles/Containers";
import { StyledP } from "../../../styles/StyledHTML";
import { IconLocation, IconPerson, IconTag } from "../../Icons";
import { StyledChip } from "../../../styles/matieralui/Chip";
import { AndOr } from './AndOr'
const StyledChipInline = styled(StyledChip)`margin-bottom: 1em !important;`

export const TagSetToggle = ({ label, tags = [], compare, onCompareChange, onRemoveTag }) => {

    const renderTagSet = () => {
        return tags.map(tag => {

            let icon = (<IconTag />)
            if (tag.type === 'location') icon = (<IconLocation />)
            else if (tag.type === 'person') icon = (<IconPerson />);

            // Ensure Data
            let display = tag;
            if (!display?.name && tags?.length > 0) {
                display = tags.find(i => i.id == tag.id);
            }


            return (
                <StyledChipInline key={display.id} icon={icon} label={display.name} clickable onDelete={() => onRemoveTag(display)} />
            )
        })
    }

    return (
        <SmartContainer width="100%">
            <StyledP>{label} {tags?.length > 1 && (<AndOr value={compare} onChange={onCompareChange} />)}</StyledP>
            <br />
            <HorizontalStack width="100%">{renderTagSet(tags)}</HorizontalStack>
        </SmartContainer>
    )
}